import { supabase } from '@/lib/supabase';

export const employeeService = {
  async list(orderBy = 'created_at') {
    const isDescending = orderBy.startsWith('-');
    const column = isDescending ? orderBy.slice(1) : orderBy;

    const { data, error } = await supabase
      .from('employees')
      .select('*')
      .order(column, { ascending: !isDescending });

    if (error) throw error;
    return data;
  },

  async getById(id) {
    const { data, error } = await supabase
      .from('employees')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getByEmployeeId(employeeId) {
    const { data, error } = await supabase
      .from('employees')
      .select('*')
      .eq('employee_id', employeeId)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getByPin(pinCode) {
    const { data, error } = await supabase
      .from('employees')
      .select('*')
      .eq('pin', pinCode)
      .eq('is_active', true)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async filter(filters) {
    let query = supabase.from('employees').select('*');

    if (filters.$or) {
      const orConditions = filters.$or;
      let orQuery = null;

      for (const condition of orConditions) {
        const [key, value] = Object.entries(condition)[0];
        if (!orQuery) {
          orQuery = query.or(`${key}.eq.${value}`);
        } else {
          orQuery = orQuery.or(`${key}.eq.${value}`);
        }
      }
      query = orQuery;
    } else {
      Object.entries(filters).forEach(([key, value]) => {
        query = query.eq(key, value);
      });
    }

    const { data, error } = await query;
    if (error) throw error;
    return data;
  },

  async create(employeeData) {
    const { data, error } = await supabase
      .from('employees')
      .insert([employeeData])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id, employeeData) {
    const { data, error } = await supabase
      .from('employees')
      .update(employeeData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id) {
    const { error } = await supabase
      .from('employees')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  }
};
